import React, { useState } from "react";
import { InView } from 'react-intersection-observer';
import HeaderAnim from "../utils/animations/textRevealAnimation";


export default function PageIntro(props) {
  const { title, header, content, classes } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  return (
    <InView onChange={(inView) => setIsVisible(inView)} >
      <div className={`page-intro-section section-gap-small ${classes}`} id={props.id ? props.id : ''}>
        <div className="container">
          <p className="theme-color-title">{isVisible && <HeaderAnim header={title} />}</p>
          <h2 className="h2">{header}</h2>
          {content}
        </div>
      </div>
    </InView>
  );
}